import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import simulateClickUtil from "../../client-utils/click/simulateClick.util.js";
import scrollElementIntoViewUtil from "../../client-utils/element/scrollElementIntoView.util.js";
import waitForElementWithDelayUtil from "../../client-utils/element/waitForElementWithDelay.util.js";
import { CENTUPLE, QUINTUPLE } from "../../constants/numbers.consts.js";
export const DesktopSteps = [
    {
        id: "start",
        selector: () => null,
        title: _jsx(_Fragment, { children: "We hebben een nieuwe gebruikerservaring voor je! \uD83C\uDF89 " }),
        description: (_jsxs(_Fragment, { children: ["Zo hebben we de manier van navigeren flink aangepakt zodat je nog makkelijker je weg vindt in de applicatie.", _jsx("br", {}), _jsx("br", {}), "Zullen we het je even laten zien?"] })),
    },
    {
        id: "navigationRail",
        selector: () => document.querySelector("[data-tourid='NavigationRailList']"),
        title: _jsx(_Fragment, { children: "Navigatiebalk" }),
        description: (_jsx(_Fragment, { children: "Aan de zijkant van de applicatie introduceren we een nieuwe visuele manier van navigeren. Ga er met je muis overheen om de onderliggende items weer te geven!" })),
    },
    {
        id: "appSwitcher",
        selector: () => document.querySelector("[data-tourid='AppBarAppSwitcherIconButton']"),
        title: _jsx(_Fragment, { children: "Snel schakelen" }),
        description: (_jsxs(_Fragment, { children: ["Maak je gebruik van meerdere SDB applicaties, dan kun je hier snel wisselen. Tip: open ze in een nieuw tabblad om in meerdere applicaties tegelijk te werken!", _jsx("br", {}), _jsx("br", {}), "Maak je gebruik van 1 van onze applicaties? Dan kun je hier snel naar Start navigeren."] })),
    },
    {
        id: "breadcrumbs",
        selector: () => document.querySelector("[data-tourid='AppBarBreadcrumbs']"),
        title: _jsx(_Fragment, { children: "Kruimelpad" }),
        description: (_jsx(_Fragment, { children: "Boven in het scherm kun je altijd zien waar je bent in de applicatie. Je kunt er zelfs mee terug navigeren door er op te klikken!" })),
    },
    {
        id: "notifications",
        selector: () => document.querySelector("[data-tourid='AppBarActionIconsNotifications']"),
        title: _jsx(_Fragment, { children: "Notificaties" }),
        description: (_jsx(_Fragment, { children: "Een nieuw Notificatiecentrum waar je direct het onderwerp van de melding kunt zien. Je kunt er dan ook direct naartoe navigeren!" })),
    },
    {
        id: "profileMenuButton",
        selector: () => document.querySelector("[data-tourid='AppBarAvatarButton']"),
        title: _jsx(_Fragment, { children: "Profielmenu" }),
        description: (_jsx(_Fragment, { children: "Daarnaast tonen we een profielmenu met toegang tot je gegevens en helpartikelen. Nog geen profielfoto? Stel deze hier in!" })),
        onNext: async () => {
            await simulateClickUtil("[data-tourid='AppBarAvatarButton']");
            await waitForElementWithDelayUtil({
                selector: "[data-tourid='FeatureDiscoverRestartButton']",
                delayAfterFound: CENTUPLE * QUINTUPLE,
                checkVisibility: true,
            });
            const restartButton = document.querySelector("[data-tourid='FeatureDiscoverRestartButton']");
            if (restartButton) {
                // in certain cases the button is not visible, so we scroll to it
                await scrollElementIntoViewUtil({ element: restartButton, scrollTime: 600 });
            }
            else {
                console.warn("Element [data-tourid='FeatureDiscoverRestartButton'] not found.");
            }
        },
    },
    {
        id: "restartButton",
        selector: () => document.querySelector("[data-tourid='FeatureDiscoverRestartButton']"),
        title: _jsx(_Fragment, { children: "Einde \uD83C\uDFAF" }),
        description: (_jsxs(_Fragment, { children: ["Wil je de uitleg nog eens bekijken? Start deze opnieuw op onder je profielmenu. ", _jsx("br", {}), _jsx("br", {}), "Werk ze!"] })),
        offset: { y: 30 },
        onBack: async () => {
            await simulateClickUtil("[data-tourid='ProfileMenuHeader'] button.MuiButtonBase-root");
        },
        onNext: async () => {
            await simulateClickUtil("[data-tourid='ProfileMenuHeaderTitle'] button.MuiButtonBase-root");
        },
        onExit: async () => {
            await simulateClickUtil("[data-tourid='ProfileMenuHeaderTitle'] button.MuiButtonBase-root");
        },
    },
];
